import React from 'react';
import { Box, Typography } from '@mui/material';
import { CalendarEventDto } from '@/types/calendar';

interface Props {
  event: CalendarEventDto;
}

export const MedicationEventDetails: React.FC<Props> = ({ event }) => {
  const d = event.details;
  if (!d) return null;

  const rawInput: string | undefined = (d as Record<string, unknown>).rawInput as string | undefined;
  const rows: { label: string; value: string }[] = [];

  if (d.medication_name) rows.push({ label: 'Назва', value: d.medication_name });
  if (d.dose) rows.push({ label: 'Доза', value: d.dose });
  if (d.frequency) rows.push({ label: 'Частота', value: d.frequency });
  if (d.notes) rows.push({ label: 'Нотатки', value: d.notes });

  if (!rawInput && !rows.length) return null;

  return (
    <>
      {rawInput && (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', lineHeight: 1.4, mt: 0.5 }}>
          «{rawInput}»
        </Typography>
      )}
      {rows.length > 0 && (
        <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 16px', alignItems: 'baseline', mt: rawInput ? 1 : 0 }}>
          {rows.map(({ label, value }) => (
            <React.Fragment key={label}>
              <Typography variant="body2" color="text.secondary">{label}</Typography>
              <Typography variant="body2">{value}</Typography>
            </React.Fragment>
          ))}
        </Box>
      )}
    </>
  );
};
